export const MODULE_NAME = "portal-support";
